module.exports = __webpack_public_path__ + "static/media/weebly.1b4e4b49.svg";